import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import type { AppConfig } from "@/types";

export async function initI18n(app: AppConfig): Promise<typeof i18n> {
  const supported = app.supportedLocales.map((locale) => locale.id);

  await i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: app.fallbackLocale,
      supportedLngs: supported,
      load: "currentOnly",
      interpolation: { escapeValue: false },
      backend: {
        loadPath: "/locales/{{lng}}.json",
      },
      detection: {
        // A language in the URL is useful for sharing locale-specific wizard
        // links and should take precedence over a previously saved choice.
        // Otherwise use the explicit in-app choice. We intentionally avoid
        // browser-language detection so first-time visitors start in English
        // UK rather than an unexpected device locale.
        order: ["querystring", "localStorage"],
        lookupQuerystring: "lang",
        lookupLocalStorage: "ew-locale",
        caches: ["localStorage"],
      },
      react: { useSuspense: false },
    });

  if (!supported.includes(i18n.language)) {
    await i18n.changeLanguage(app.defaultLocale);
  }

  document.documentElement.lang = i18n.language;
  return i18n;
}

export function persistLocale(locale: string): void {
  localStorage.setItem("ew-locale", locale);
  document.documentElement.lang = locale;
}
